import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { SyncService } from '../../sync.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpService } from '../../http.service';

@Component({
	selector: 'deals',
	templateUrl: './deals.component.html',
	styleUrls: ['./deals.component.css'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('fadeIn', [
			transition(':enter', [
				style({ opacity: 0}),
				animate('125ms ease-in', style({ opacity: 1 }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0}))
			])
		]),
		trigger('fadeInUp', [
			transition(':enter', [
				style({ opacity: 0, transform: 'translateY(-2px)' }),
				animate('125ms ease-in', style({ opacity: 1, transform: 'translateY(0)' }))
			]),
			transition(':leave', [
				animate('125ms ease-out', style({ opacity: 0, transform: 'translateY(2px)' }))
			])
		])
	]
})
export class DealsComponent implements OnInit, OnDestroy {

	userData: any;
	currentDeal = '';
	displayDeals: any[] = [];
	hoveringOverItem = '';
	validateUrl = environment.validateUrl;
	theme = 'white';
	email = '';
	private subscription: any;

	constructor(
		public httpService: HttpService,
		public syncService: SyncService,
		private cdr: ChangeDetectorRef,
		private http: HttpClient
	) {}

	ngOnInit() {

		if (this.subscription) {
			this.subscription.unsubscribe();
		}

		this.httpService.wakeUpServer();

		if (this.syncService.authStatus.getValue() !== 'authenticated') {
			this.syncService.updateAuthStatus('unauthenticated');
			this.syncService.updatePage('login');
			return;
		}

		this.syncService.email$.subscribe((email) => {
			this.email = email;
		});

		this.subscription = this.syncService.userData$.subscribe((data) => {
			this.userData = data;
			this.displayDeals = data['Deals'];
			this.cdr.detectChanges();
		});

		this.syncService.currentDeal$.subscribe((deal) => {
			this.currentDeal = deal;
		});

		this.syncService.theme$.subscribe((theme) => {
			this.theme = theme;
		});
	}

	searchDeal($event: string) {
		const searchString = $event;
		this.displayDeals = this.userData['Deals'].filter((deal: any) => deal['Deal Name'].toLowerCase().includes(searchString.toLowerCase()));
	}

	aggregateDeal(deal: any) {
		this.syncService.updateCurrentDeal(deal['Deal Name']);
		// this.syncService.updatePage('files');
		this.httpService.aggregate(deal);
		this.syncService.updatePage('fund-data');
	}

	viewFiles(deal: any) {
		this.syncService.updateCurrentDeal(deal['Deal Name']);
		this.syncService.updatePage('files');
	}

	openDealDeletionModal(dealName: string) {
		this.syncService.updateDealPendingDeletion(dealName);
		this.syncService.updateDealDeletionModalOpen(true);
	}

	enteringContainedListItem(key: any) {
		this.hoveringOverItem = key;
	}

	openDealEditModal(dealName: string) {
		this.syncService.updateCurrentDeal(dealName);
		this.syncService.updateDealEditModalOpen(true);
	}

	onClickUploadFiles(currentDeal: string) {
		this.currentDeal = currentDeal;
		this.syncService.updateCurrentDeal(this.currentDeal);
		this.syncService.updatePage('upload-files');
	}

	checkDealStatus(deal: any) {
	if (deal['Files'].length === 0) {
		return 'inactive';
	}
	let dealStatus = 'finished';
	for (let i = 0; i < deal['Files'].length; i++) {
		const file = deal['Files'][i];
		const fileStatus = file['File Status'];
		if (fileStatus === 'error') {
			return 'error';
		} else if (fileStatus === 'inactive' && dealStatus !== 'error') {
			dealStatus = 'inactive';
			return 'error';
		} else if (fileStatus === 'active') {
			if (new Date().getTime() - file['Timestamp'] > 60 * 1000 * 60) {
				return 'error';
			} else {
				return 'active';
			}
		}
	}
	return dealStatus;
}

	submitDeal(dealName: string) {
		this.syncService.updateNotificationType('success');
		this.syncService.updateNotificationTitle('We\'ll start pricing ' + dealName + ' shortly.');
		this.syncService.updateNotificationSubtitle('We\'ll notify you once the process is complete.');
		this.syncService.updateShowNotification(true);
		const formData: FormData = new FormData();
		formData.append('Email', this.userData['Email']); // DONE
		formData.append('Deal Name', dealName);
		const headers = new HttpHeaders();
		this.http.post(this.validateUrl, formData, { headers }).subscribe();
		setTimeout(() => {
			this.syncService.updateShowNotification(false);
		}, 5000);
	}

	ngOnDestroy() {
		this.subscription?.unsubscribe();
	}
}
